export default __webpack_public_path__ + "static/media/radio-disabled.15d7be3b.svg";